export const CompanyQueryKeys = {
	all: ['company'] as const,
	departments: () => [...CompanyQueryKeys.all, 'departments'] as const,
	settings: () => [...CompanyQueryKeys.all, 'settings'] as const,
};